import styles from '../../css/toasts/ToastContainer.module.css';

const ToastContainer = ({ children, position = 'bottom-center' }) => {
  return (
    <div className={`${styles.container} ${styles[position]}`}>
      {children}
    </div>
  );
};

export default ToastContainer;
